import { Injectable, NgZone } from '@angular/core';
import { RoutingService } from './routing-service';
import { ProvidehttpService } from './providehttp.service';
import { Data } from './DataService';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { AlertsService } from './AlertsService';
import { KeycloakService } from 'keycloak-angular';
import { HttpResponse } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import { AuthService } from './auth.service';
import { environment } from 'src/environments/environment';
import { MobileService } from './mobile.services';
import { ILimitDraft } from "./limitdraft.service";
import { map } from 'rxjs/operators';
import { combineLatest, Observable, Subscriber } from 'rxjs';
import { TransactionCategory } from './models/transaction-category.model';
import { Merchant } from './models/merchants.model';
import { CustomerService } from './services/customer.service';
import { AccTranDetails, TransactionDetail } from './models/transaction-detail.model';
import { LoanDetails } from './models/loan-details.model';
import { LoanTranDetails, LoanTransactionDetail } from './models/loan-transaction-detail.model';
import { DepositDetail } from './models/Deposit-details.model';
import { DebitCardDetail } from './models/Debit-card-details.model';
import { DepositOverview } from './models/Deposit-Overview.model';
import { ICreditCardSummaryData } from './common/models/credit-card.model';
import { AccountsService } from './services/accounts/accounts.service';
import { AccountDetails, ILoanProduct, ILoans, IMutualFunds, IMutualFundsProduct, IOverview, ITermDepositDetails, ITermDepositProduct } from './models/account-info.model';
import { CommonService } from './common.service';
import { UserService } from './user.service';
import { NFCCheck } from './models/nfc-check';
import { Diagnostic } from "@ionic-native/diagnostic/ngx";

import{
  HttpProviderService,
  HttpRequest
}from '@fpx/core';
declare let $: any;
window["$"] = $;
window["jQuery"] = $;

@Injectable({
  providedIn: 'root'
})

export class RetailStock {
  accountsToResult: any;
  activeCardIndex: number = -1;
  loanSummary: LoanDetails[];
  depositSummary: ITermDepositProduct[];
  debitCardSummary: DebitCardDetail[];
  depositOverview: DepositOverview;
  creditCardSummary: ICreditCardSummaryData[];
  mutualFundsSummary: IMutualFundsProduct[];
  isNFCPresent: boolean = false;
  paymentMethodData;
  nickdata;
  constructor(public routing: RoutingService,
    public http: ProvidehttpService,
    public dataStore: Data,
    public modal: NgbModal,
    public translate: TranslateService,
    public router: Router,
    public alert: AlertsService,
    public ngZone: NgZone,
    private keycloakService: KeycloakService,
    private authService: AuthService,
    public mobile: MobileService,
    public customerService: CustomerService,
    private accountsService: AccountsService,
    private _commonService:CommonService,
    public _userService:UserService,
    private _httpProvider : HttpProviderService,
    private diagnostic: Diagnostic,
    public _customerService: CustomerService) {
    $(document).on("cut copy paste", "input", function (evt) {
      const classList = evt.target.className.split(' ')
        if( !classList.includes('allow-paste')){
          evt.preventDefault()
        }else {
          console.log('allowed')
        }
    });

     
    this.diagnostic
      .isNFCPresent()
      .then((isEnabled) => {
        this.isNFCPresent = isEnabled;
        // alert(this.isNFCPresent);
      })
      .catch((e) => console.error(e));
  
  }
  repeatUrl;
  public nickNameData;
  public userDetails = [];
  public fullUserProfileData = {};
  public hasAccount: boolean = false;
  public flexpayCardData: any;
  public activeFlexPayList: any;
  public closedFlexPayList: any;
  /*SANTHOSH 26-12-2021 BEGIN*/
  public searchRequired: boolean = false;
  public serviceDescription: string = "";
  public backBtnUrl= undefined;
  public isbackBtn = false;
  /*SANTHOSH 26-12-2021 END*/
  CBD: any;
  accountSummaryCA: AccountDetails[];
  accountSummarySA: AccountDetails[];
  summaryData: IOverview;
  merchant: Merchant[];
  nfc: NFCCheck[];
  merchantMap:any;
  transactionCategory: TransactionCategory[];
  transactionCatMap:any;
  accTransactionDetail: any = [];
  flexPayTrxCustomer: any = [];

  headerRequired: boolean = true;
  footerRequired: boolean = true;
  paymentOption: string = "new";

  paymentData: any;
  toOwnAccountTransfer: any;

  riskGradingDetails: any;
  odLimitData: any;
  flexpayLimit: any;

  personalDetails: any;

  limitResponseDraftData: ILimitDraft;
  isShowStartOrResume: boolean = false;
  currentStage: "LimitSelection" | "LimitAdjustment" | "AdditionalDetails" | "AccountCrawl" | "AdditionalDetailSummary" | "ContractScreen";
  isLimitPost: boolean = true;

  primaryAccIBAN: string = "";
  primaryAcc: any

  referalCode: string = '';
  paymentsEntryPoint = '';

  fetchUserDetails(): any {
    let inputMap = new Map();
    inputMap.clear();
    inputMap.set('PathParam.userId', this._userService.getCustomerCode());
    return this.http.fetchApi('/customer/{userId}', 'GET', inputMap, this.getEnvironment().customersPublisher).pipe(
      map(
        (res) => {
          return res.body['customer'];
        }
      )
    );
  }

  async getAccountSummary(fullUserProfileData) {
    let inputMap = new Map();
    let accounNickJson = null;
    inputMap.clear();
    // inputMap.set('QueryParam.customerCode', sessionStorage.getItem('customerCode'));
    this.http.fetchApi('/accountnickname', 'GET', inputMap, '/cbx-common/publisher').subscribe(
      async (httpResponse: HttpResponse<any>) => {
        var res = httpResponse.body;
        if (res) {
          accounNickJson = res['accountnickname'];
          var loopVar27 = res['accountnickname'];
          var loopDataVar38 = [];
          if (loopVar27) {
            for (var i = 0; i < loopVar27.length; i++) {
              let tempJson = { 'accountNumber': loopVar27[i].accountNumber, 'nickName': loopVar27[i].nickName };
              loopDataVar38.push(tempJson)
            }
            sessionStorage.setItem('allNickName', JSON.stringify(loopDataVar38));
          }
        }
      },
      async (httpError) => {
        var err = httpError['error']
        if (err != null && err['ErrorElementPath'] != undefined && err['ErrorDescription'] != undefined) {
        }
      }
    );
    setTimeout(() => {
      inputMap.clear();
      // inputMap.set('QueryParam.CustomerCode', sessionStorage.getItem('customerCode'));
      this.http.fetchApi('/channel/accountSummary', 'GET', inputMap, '/cbx-accounts/publisher').subscribe(
        async (httpResponse: HttpResponse<any>) => {
          var res = httpResponse.body;
          if (res) {
            let nickCardData: any = [];
            let accountData: any = [];
            var loopVar27 = res['AccountSummary'];
            var loopDataVar38 = [];
            if (loopVar27) {
              for (var i = 0; i < loopVar27.length; i++) {
                let tempProduct: any = '';
                let filterAccNum: any = loopVar27[i].accountNumber;
                var matchAccountNumber = null;
                if (accounNickJson != null) {
                  matchAccountNumber = accounNickJson.find(obj => {
                    return obj.accountNumber === filterAccNum
                  });
                }

                if (matchAccountNumber != null) {
                  if (matchAccountNumber.nickName != "") {
                    tempProduct = matchAccountNumber.nickName;
                  }
                }
                let tempJson: any = {};

                let tempNickJson: any = {};
                if (tempProduct) {
                  tempJson = { 'accountNumber': loopVar27[i].accountNumber, 'accountName': loopVar27[i].accountName, 'product': tempProduct, 'originalProduct': loopVar27[i].product };
                }
                else {
                  tempJson = { 'accountNumber': loopVar27[i].accountNumber, 'accountName': loopVar27[i].accountName, 'product': loopVar27[i].product, 'originalProduct': loopVar27[i].product };
                }

                loopDataVar38.push(tempJson)

              }
            }
            // this.userDetails.push(this.fullUserProfileData)
            this.fullUserProfileData["allAccountsSummaryData"] = loopDataVar38
            sessionStorage.setItem('allAccountsSummaryData', JSON.stringify(loopDataVar38));
            fullUserProfileData(this.fullUserProfileData)
          }
        },

        async (httpError) => {
          var err = httpError['error']
          if (err != null && err['ErrorElementPath'] != undefined && err['ErrorDescription'] != undefined) {
          }
        }
      );
    }, 3000);

  }

  getUserImage(successCallback) {
    let inputMap = new Map();
    inputMap.clear();
    inputMap.set('PathParam.userId', sessionStorage.getItem('username'));

    this.http.fetchApi('/userprofile/{userId}', 'GET', inputMap, this.getEnvironment().customersPublisher).subscribe(
      async (httpResponse: HttpResponse<any>) => {
        var res = httpResponse.body;
        var imageData;
        if (res && res['userprofile'] && res['userprofile']['photo']) {
          imageData = res['userprofile']['photo'];
          this.dataStore.setData('userImage', imageData);
          this._userService.userImage = imageData;
        } else {
          imageData = null;
          this.dataStore.setData('userImage', undefined);
        }

        if(res && res['userprofile'] && res['userprofile']['lastLoginDateTime']) {
          this._userService.setLastLoginDate(res['userprofile']['lastLoginDateTime']);
        }
        if(res && res['userprofile'] && res['userprofile']['lastFailedLogin']) {
          this._userService.setLastLoginFailureDateTime(res['userprofile']['lastFailedLogin']);
        }
        if (successCallback) successCallback(imageData);
      },
      async (httpError) => {
        if (successCallback) successCallback(null);
        var err = httpError['error']
        if (err != null && err['ErrorElementPath'] != undefined && err['ErrorDescription'] != undefined) {
        }
      }
    );
  }

  helloText() {
    let msg:any;
    let data = [
      [22, 'HelloText.workingLate'],
      [18, 'HelloText.goodEvening'],
      [12, 'HelloText.goodAfternoon'],
      [5, 'HelloText.goodMorning'],
      [0, 'HelloText.earlyBird']
    ];
    let hr:any = new Date().getHours();

    for (var i = 0; i < data.length; i++) {
      if (hr >= data[i][0]) {
        msg = data[i][1];
        break;
      }
    }
    return msg;
  }


  auditRouter(navPath) {
    let tempPath = navPath.split('/')
    let currentNavPath = tempPath[tempPath.length - 1]
    if ((currentNavPath.includes(this.repeatUrl) && this.dataStore.isMobile()) || (currentNavPath.includes('dashboard') || currentNavPath.includes('dashboard') || currentNavPath.includes('home') || currentNavPath.includes('accounts') || currentNavPath.includes('loans') || currentNavPath.includes('investments') || currentNavPath.includes('mailbox') || currentNavPath.includes('tools') || currentNavPath.includes('services') || currentNavPath.includes('settings'))) {
      return
    }
    this.repeatUrl = currentNavPath;
    let serviceList = this.dataStore.getData('serviceList');
    var serviceCode = null;
    if (serviceList) {
      if (currentNavPath != 'voidCheck') {
        for (var i = 0; i < serviceList.length; i++) {
          if (currentNavPath.includes(serviceList[i].componentId)) {
            serviceCode = serviceList[i].serviceCode
          }
        }
      }
      if (serviceCode == null && currentNavPath != 'voidCheck') {
        return
      } else {
        let inputMap = new Map();
        inputMap.clear();
        inputMap.set('Body.quicklinks.userId', sessionStorage.getItem('email'));
        if (currentNavPath == 'voidCheck') {
          inputMap.set('Body.quicklinks.serviceCode', 'voidCheque');
        } else {
          inputMap.set('Body.quicklinks.serviceCode', serviceCode);
        }
        this.http.fetchApi('/quicklinks', 'POST', inputMap, '/cbx-common/publisher').subscribe(
          async (httpResponse: HttpResponse<any>) => {
            var res = httpResponse.body;
          },
          async (httpError) => {
            var err = httpError['error']
            if (err != null && err['ErrorElementPath'] != undefined && err['ErrorDescription'] != undefined) {
            }
          }
        );
      }
    }
  }

  getLastLoginInfo(lastloginDate) {
    let inputMap = new Map();
    inputMap.clear();
    // this.services.http.fetchApikeycloak('/account/sessions/devices', 'GET', inputMap).subscribe(
    this.http.fetchApikeycloak('/cbxr/lastLoginInfo', 'GET', inputMap).subscribe(
      async (httpResponse: HttpResponse<any>) => {
        var res = httpResponse.body;
        if (res[0].lastAccess == '') {
          lastloginDate('');
          return;
        }
        var lastAccessDate = new Date(parseInt(res[0].lastAccess));
        var dateOptions: any = { month: 'short', day: '2-digit', year: 'numeric' };
        var timeOptions: any = { hour: '2-digit', minute: '2-digit' };
        lastloginDate(lastAccessDate.toLocaleDateString('en', dateOptions) + " " + lastAccessDate.toLocaleTimeString('en', timeOptions));
      },
      async (httpError) => {
        var err = httpError['error']
        if (err != null && err['ErrorElementPath'] != undefined && err['ErrorDescription'] != undefined) {
        }
      }
    );
  }

  async fetchRiskGradingDetails() {
    console.log("1A");
    let inputMap = new Map();
    inputMap.clear();
    inputMap.set('PathParam.userId', sessionStorage.getItem('customerCode'));
    await this.http.fetchApi('/risk-grading/{userId}', 'GET', inputMap, this.getEnvironment().accountsPublisher).toPromise().then(
      async (httpResponse: HttpResponse<any>) => {
        var res = httpResponse.body;
        if (res && res['RiskGradingDetails']) {
          this.riskGradingDetails = res['RiskGradingDetails'][0];
        }
        await this.loadFromDraft();
        console.log("1B");
      },
      async (httpError) => {
        var err = httpError['error']
        if (err != null && err['ErrorElementPath'] != undefined && err['ErrorDescription'] != undefined) {
        }
      }
    );
    console.log("1C");
  }

  async loadSummary() {
    let summaryRes: any;
    let accounts = [];
    // let data = this.accountsService.getList();

    if(this.customerService.customerInfo.accountInfo.accountDetails){
      this.accountSummaryCA = this.customerService.customerInfo.accountInfo.accountDetails.map((item)=>{
        return {
          ...item,
          category:"account", isAccountCard:true, isAccount: true
        }
      });
      accounts.push({
        category: "account",
        label: 'OVERVIEWUI.PORTFOLIOSUMMARYLIST.Accounts',
        summary: this.accountSummaryCA,
        total: this.customerService.customerInfo.accountInfo.totalCASAAmount,
        currency: this.accountSummaryCA[0].accountCurrency,

      });
    } else {
      if(this.customerService.getAccount('CA')){
        this.accountSummaryCA = this.customerService.getAccount('CA').map((item)=>{
          return {...item, category:"CA", isAccountCard:true, isAccount: true}
        });
        accounts.push({
          category: "account",
          label: 'OVERVIEWUI.PORTFOLIOSUMMARYLIST.currentAccount',
          summary: this.accountSummaryCA,
          total: this.customerService.customerInfo.accountInfo.totalCAAmount,
          currency: this.accountSummaryCA[0]?.accountCurrency,
          accountType: 'CA'
        });
      }

      const saAccounts = this.customerService.getAccount('SA');
      if (Array.isArray(saAccounts) && saAccounts.length > 0) {
        this.accountSummarySA = saAccounts.map((item)=>{
          return {...item, category:"SA",
          // nickName: this.accountsService.getNickname(item.accountNumber),
          isAccountCard:true, isAccount: true,}
        });

        accounts.push({
          category: "account",
          label: 'OVERVIEWUI.PORTFOLIOSUMMARYLIST.savingAccounts',
          summary: this.accountSummarySA,
          total: this.customerService.customerInfo.accountInfo.totalSAAmount,
          currency: this.accountSummarySA[0]?.accountCurrency,
          accountType: 'SA'
        });

        // this.customerService.customerInfo.accountInfo.accountDetails = [...this.accountSummaryCA, ...this.accountSummarySA];

      } else {
        accounts.push({
          category: "account",
          label: 'OVERVIEWUI.PORTFOLIOSUMMARYLIST.savingAccounts',
          summary: [],
          accountType: 'SA'
        });
      }
    }


    if(this.customerService.customerInfo.accountInfo.loans){
      let loanSummary = this.customerService.getLoanAccounts();
      accounts.push({
        category: "loan",
        label: "Loans",
        summary: loanSummary,
        accountType: 'loan',
        total: this.customerService.customerInfo.accountInfo.loans.totalOutstandingAmount,
        currency: this._commonService.baseCurrency
      });
    }

    if(this.customerService.customerInfo.accountInfo.termDeposits){
      this.depositSummary = this.customerService.getDepositSummary();
      accounts.push({
        category: "deposit",
        label: 'OVERVIEWUI.PORTFOLIOSUMMARYLIST.deposits',
        summary: this.depositSummary,
        total: this.depositSummary?.[0]?.totalDepositAmount,
        currency: this._commonService.baseCurrency,
        accountType: 'deposit'
      });
    } else {
      accounts.push({
        category: "deposit",
        label: 'OVERVIEWUI.PORTFOLIOSUMMARYLIST.deposits',
        summary: [],
        accountType: 'deposit'
      });
    }


    if(this.customerService.customerInfo.accountInfo.loans){
      let loanSummary = this.customerService.getLoanAccounts();
      accounts.push({
        category: "loan",
        label: "Loans",
        summary: loanSummary,
        accountType: 'loan',
        total: this.customerService.customerInfo.accountInfo.loans.totalOutstandingAmount,
        currency: this._commonService.baseCurrency
      });
    }



    if(this.customerService.customerInfo.accountInfo.mutualFunds){
      this.mutualFundsSummary = this.customerService.getMutualFundsSummary();
      accounts.push({
        category: "mutualFund",
        label: 'OVERVIEWUI.PORTFOLIOSUMMARYLIST.mutualFunds',
        summary: this.mutualFundsSummary,
        total: this.customerService.customerInfo.accountInfo.mutualFunds.totalUnits || 0,
        currency: this._commonService.baseCurrency,
        accountType: 'mutualFund'
      });
    }

    if(this.customerService.customerInfo.accountInfo.creditCardDetails){
      let _data = this.customerService.customerInfo.accountInfo.creditCardDetails;
      const totalOutstanding = _data.reduce((ttlOutstanting, item) => ttlOutstanting + Number(item.outstandingAmount), 0);
      let creditCardsList = this.customerService.customerInfo.accountInfo.creditCardDetails.map((item) => {
        return {
          ...item,
          'category': 'credit-card'
        }
      });

      accounts.push({
        category: "creditCard",
        label: 'OVERVIEWUI.PORTFOLIOSUMMARYLIST.creditCard',
        summary: creditCardsList,
        total: totalOutstanding || 0,
        currency: this.customerService.customerInfo.accountInfo.creditCardDetails[0].currency,
        accountType: 'creditCard'
      });
    }

    this.summaryData = {
      accounts: accounts
    }

    let _hasAccount = this.customerService.customerInfo?.accountInfo?.accountDetails?.length ||
    this.customerService.customerInfo?.accountInfo?.currentAccounts?.length ||
    this.customerService.customerInfo?.accountInfo?.savingsAccounts?.length || 0;
    if (_hasAccount) {
      localStorage.setItem("hasAcc", 'true');
      this.hasAccount = true;
      summaryRes = 'overview';
    } else {
      summaryRes = 'openAccount';
    }

    summaryRes = 'overview';

    return summaryRes;
  }

  async loadCustomerData() {
    let inputMap = new Map();
    inputMap.clear();
    inputMap.set('PathParam.userId', this._userService.getCustomerCode());
    await this.http.fetchApi('/customer/{userId}', 'GET', inputMap, this.getEnvironment().customersPublisher).toPromise().then(
      async (httpResponse: HttpResponse<any>) => {
        if(httpResponse && httpResponse.body){
          this._customerService.customerInfo = httpResponse.body['customer'];
        }
      },
      async (httpError) => {
        var err = httpError['error']
        if (err != null && err['ErrorElementPath'] != undefined && err['ErrorDescription'] != undefined) {
        }
      }
    );
    console.log("5C");
  }
  async loadMerchantData() {
    console.log("5A");
    let inputMap = new Map();
    inputMap.clear();
    await this.http.fetchApi('/merchant', 'GET', inputMap, this.getEnvironment().accountsPublisher).toPromise().then(
      async (httpResponse: HttpResponse<any>) => {
        if(httpResponse && httpResponse.body){
          var res:Merchant[] = httpResponse.body['merchant'];
          if (res) {
            this.merchant = res;
          }
        }
        console.log("5B");
      },
      async (httpError) => {
        var err = httpError['error']
        if (err != null && err['ErrorElementPath'] != undefined && err['ErrorDescription'] != undefined) {
        }
      }
    );
    console.log("5C");
  }

async loadNFC() {
  console.log("(9A");


   if (!this.mobile.isHybrid()) {
    
    return; 
  }
  
  const nfcData: NFCCheck = {
    isNfcSupported: this.checkNfcSupport(),
    deviceId: this.getOrCreateDeviceId(),
    deviceName: this.getDeviceName()
  };

  const bodyContent = {
    "nfcIndicator": nfcData
  };

  console.log("Framed Payload:", bodyContent);

  const httpRequest = new HttpRequest();
  httpRequest.setMethod('POST');
  httpRequest.setServerContext(this.getEnvironment().commonPublisher);
  httpRequest.setResource('/nfcIndicator');
  httpRequest.setBody(bodyContent);

  try {
    const response: any = await this._httpProvider.invokeRestApi(httpRequest).toPromise();
    
    if (response && response.body) {
      const res: NFCCheck[] = response.body['nfc'];
      if (res) {
        this.nfc = res;
      }
    }
    console.log("9B - Success");
  } catch (httpError: any) {
    const err = httpError['error'];
    if (err != null && err['ErrorElementPath'] !== undefined && err['ErrorDescription'] !== undefined) {
       console.error("NFC API Error:", err['ErrorDescription']);
    }
  }

  console.log("9C");
}

private getDeviceName(): string {
  return this.mobile.device.model?.toString();
}

private checkNfcSupport(): string {

if( this.isNFCPresent){
return "Y";
}else{
return "N";
}
  
}


private getOrCreateDeviceId(): string {
  return this.mobile.getDeviceId()?.toString();
}
  
  async loadTransactionCodeData() {
    console.log("6A");
    let inputMap = new Map();
    inputMap.clear();
    await this.http.fetchApi('/transactioncategory', 'GET', inputMap, this.getEnvironment().accountsPublisher).toPromise().then(
      async (httpResponse: HttpResponse<any>) => {
        if(httpResponse && httpResponse.body){
          var res:TransactionCategory[] = httpResponse.body['transactioncategory'];
          if (res) {
            this.transactionCategory = res;
          }
        }

        console.log("6B");
      },
      async (httpError) => {
        var err = httpError['error']
        if (err != null && err['ErrorElementPath'] != undefined && err['ErrorDescription'] != undefined) { }
      }
    );
    console.log("6C");
  }

  async fetchAccountStmt() {
    console.log("7A");
    await this.loadAccountstatement();
    if(this.customerService.customerInfo.accountInfo.termDeposits) await this.loadDepositCard();
    if(this.customerService.customerInfo.accountInfo.loans) await this.loadLoanCard();
    if(this.customerService.customerInfo.accountInfo.mutualFunds) await this.loadMutualFundsCard();
    await this.loadCreditCardData();

    console.log("7B");
  }

  async loadDepositCard(){
    let depositCards:ITermDepositDetails = this.customerService.getDepositOverview();
    if(depositCards && depositCards.product){
      depositCards.product.forEach(element => {
        let depositCardData = {
          ...element,
          currency: this._commonService.baseCurrency,
          isDeposit: true,
          category: 'deposit',
          deposits: element.accountDetails
        };
        this.accTransactionDetail.push(depositCardData);
      });
    }
  }

  async loadDepositOverview(){
    let depositOverviewData:ITermDepositDetails = this.customerService.getDepositOverview();
    if(depositOverviewData){
      let depositCardData = {
        ...depositOverviewData,
        currency: "EGP",
        isDeposit: true,
        category: 'deposit',
        deposits: this.customerService.getDepositDetails()
      };
      this.accTransactionDetail.push(depositCardData);
    }
  }

  async setDepositDetails() {
    if (this.customerService.getDepositDetails()) {
      let depositCardData = {
        depositOverview: this.customerService.getDepositOverview(),
        isDepositAccount: true,
        accountNumber: this.customerService.getDepositDetails()[0].accountNumber,
        depositDetails: this.customerService.getDepositDetails()
      };
      this.accTransactionDetail.push(depositCardData);
    }
  }

  async loadMutualFundsCard(){
    let mutualFunds: IMutualFunds = this.customerService.getMutualFundsOverview();
    if(mutualFunds && mutualFunds.product){
      mutualFunds.product.forEach(element => {
        let fundCardData = {
          ...element.accountDetails[0],
          currency: this._commonService.baseCurrency,
          category: 'mutualFund'
        };
        this.accTransactionDetail.push(fundCardData);
      });
    }
  }

  async loadCreditCardData(){
    const creditCardSummary:ICreditCardSummaryData[] = this.customerService.getCreditCardSummary();
    for (var i = 0; i < creditCardSummary?.length; i++) {
      const cardData = {...creditCardSummary[i], category: 'creditCard' }
      this.accTransactionDetail.push(cardData);
    }
  }

  async loadLoanCard(): Promise<any> {
    let loans:ILoans = this._customerService.getLoanSummaryDetails();

    if(loans && loans.product){
      loans.product.forEach(element => {
        let loanCardData = {
          ...element,
          currency: this._commonService.baseCurrency,
          isLoan: true,
          category: 'loan',
          loans: element.accountDetails
        };

        this.accTransactionDetail.push(loanCardData);
      });
    }
  }

  async loadLoanStatement(): Promise<any> {
    console.log("8A");
    let inputMap = new Map();
    for (var k = 0; k < this.loanSummary.length; k++) {
      var loanTranDetail:LoanTranDetails;
      loanTranDetail = {...this.loanSummary[k], transactionDetails: [] }
      this.accTransactionDetail.push(loanTranDetail);
    }
    sessionStorage.setItem('accTransactionDetail', JSON.stringify(this.accTransactionDetail));
    console.log("8B");
  }
  async loadAccountstatement(): Promise<any> {
    console.log("8A");
    this.accTransactionDetail = [];
    let accounts = [];
    if(this.accountSummaryCA){
      accounts = accounts.concat(this.accountSummaryCA);
    }
    if(this.accountSummarySA){
      accounts = accounts.concat(this.accountSummarySA);
    }
    this.accTransactionDetail = await this.accountsService.loadAccountstatement(accounts, this.merchant, this.transactionCategory);
    console.log("8B");
  }

  async loadStatement(accNo,pageNo): Promise<any> {
    let inputMap = new Map();
      var tempAccTrxDetailtemp = [];
      const accStatementDetail = this.accountSummaryCA.find(item => item.accountNumber == accNo)
      inputMap.clear();
      inputMap.set('PathParam.accountNumber', accNo);
      const data =  await this.http.fetchApi(`/transaction/{accountNumber}?recordCount=10&requestedPage=${pageNo}`, 'GET', inputMap, this.getEnvironment().accountsPublisher).toPromise()
        .then(async (httpResponse: HttpResponse<any>) => {
          var res:TransactionDetail[] = httpResponse.body.transaction;
          if (res) {
            var loopVar36 = res;
            if (loopVar36) {
              for (var j = 0; j < loopVar36.length; j++) {
                let tempObj = {};
                tempObj['accountNumber'] = accNo;
                tempObj['transactionDesc'] = loopVar36[j].transactionDesc;
                tempObj['transactionDate'] = loopVar36[j].transactionDate;
                tempObj['merchantId'] = loopVar36[j].merchantId;
                tempObj['transactionCurrency'] = loopVar36[j].transactionCurrency;
                tempObj['transactionCat'] = loopVar36[j].transactionCat;
                tempObj['dbcrFlag'] = loopVar36[j].dbcrFlag;
                tempObj['transactionAmount'] = loopVar36[j].transactionAmount;
                tempObj['transactionRef'] = loopVar36[j].transactionRef;
                tempObj['transactionRemarks'] = loopVar36[j].transactionRemarks;
                tempAccTrxDetailtemp.push(tempObj);
              }
              return tempAccTrxDetailtemp
            }
          }
        },
          async (httpError) => {
            var err = httpError['error']
            if (err != null && err['ErrorElementPath'] != undefined && err['ErrorDescription'] != undefined) { }
            return null
          }
        );
        return data;
  }

  getEnvironment() {
    return environment;
  }

  async updateSummary(refreshSummary$?:Subscriber<any>) {
    let loadMerchantData$ = new Observable<boolean>((observer) => {
      setTimeout(async () => {
        if (!this.merchant.length) await this.loadMerchantData();
        observer.next(true);
      });
    });

    let loadNFC$ = new Observable<boolean>((observer) => {
      setTimeout(async () => {
        if (!this.nfc.length) await this.loadNFC();
        observer.next(true);
      });
    });

    let loadTransactionCodeData$ = new Observable<boolean>((observer) => {
      setTimeout(async () => {
        if (!this.transactionCategory.length) await this.loadTransactionCodeData();
        observer.next(true);
      });
    });

    let fetchRiskGradingDetails$ = new Observable<boolean>((observer) => {
      setTimeout(async () => {
        await this.fetchRiskGradingDetails();
        observer.next(true);
      });
    });

    let loadSummary$ = new Observable<boolean>((observer) => {
      setTimeout(async () => {
        await this.loadSummary();
        observer.next(true);
      });
    });

    combineLatest(loadMerchantData$, loadTransactionCodeData$, fetchRiskGradingDetails$, loadSummary$, loadNFC$).subscribe(([loadMerchantData, loadTransactionCodeData, fetchRiskGradingDetails, loadSummary, loadNFC]) => {
      if (`${loadMerchantData}` && `${loadTransactionCodeData}` && `${fetchRiskGradingDetails}` && `${loadSummary}` && `${loadNFC}`) {

        let fetchAccountStmt$ = new Observable<boolean>((observer) => {
          setTimeout(async () => {
            await this.fetchAccountStmt();
            observer.next(true);
          });
        });

        combineLatest(fetchAccountStmt$).subscribe(([fetchAccountStmt]) => {
          if (`${fetchAccountStmt}`) {
            refreshSummary$.next(true);
          }
        });

      }
    });
  }

  async refreshSummary(){
        this._commonService.showSpinner();
        await this.loadCustomerData();
        if (!this.merchant.length) await this.loadMerchantData();
        if (!this.nfc.length) await this.loadNFC();
        if (!this.transactionCategory.length) await this.loadTransactionCodeData();
        // await this.fetchRiskGradingDetails();
        // await this.loadFromDraft();
        await this.loadSummary();
        await this.fetchAccountStmt();
        this._commonService.hideSpinner();
        return true;
  }

  async refreshHistory(historyObserver){
    let loadSummary$ = new Observable<boolean>((observer) => {
      setTimeout(async () => {
        await this.loadSummary();
        observer.next(true);
      });
    });

    let fetchAccountStmt$ = new Observable<boolean>((observer) => {
      setTimeout(async () => {
        await this.fetchAccountStmt();
        observer.next(true);
      });
    });

    combineLatest(loadSummary$, fetchAccountStmt$).subscribe(([loadSummary, fetchAccountStmt]) => {
      if (`${loadSummary}` && `${fetchAccountStmt}`) {
        historyObserver.next(true);
      }
    });

    // await this.loadSummary();
    // await this.fetchAccountStmt();
    // return true;
  }

  async loadFromDraft() {
    console.log("2A");
    let inputMap = new Map();
    inputMap.clear();
    inputMap.set("PathParam.userId", sessionStorage.getItem("customerCode"));
    inputMap.set("PathParam.draftType", "LT");
    await this.http.fetchApi("/userdraft/{userId}/{draftType}", "GET", inputMap, this.getEnvironment().commonPublisher).subscribe(
      async (httpResponse: HttpResponse<any>) => {
        var res = httpResponse.body;
        if (res) {
          this.limitResponseDraftData = JSON.parse(res.userdraft.draftContent).draftContent;
          this.isLimitPost = false;
          if (this.limitResponseDraftData) this.isShowStartOrResume = true;
          this.currentStage = this.limitResponseDraftData.currentStage;
          console.log(res);
        } else {
          this.limitResponseDraftData = null;
          this.isLimitPost = true;
          this.isShowStartOrResume = false;
          this.currentStage = null;
        }
        console.log("2B");
      },
      async (httpError) => {
        var err = httpError["error"];
        if (err != null && err["ErrorElementPath"] != undefined && err["ErrorDescription"] != undefined) {
        }
      }
    );
  }

  getMerchantData(merchantId): Merchant {
    let merchantData = this.merchant?.find((obj) => {
      return obj.merchantId === merchantId;
    });
    return merchantData;
  }

  getTransactionCatData(transactionCat:any): TransactionCategory{
    let transactionCatData = this.transactionCategory.find((obj) => {
      return obj.tranCat === transactionCat;
    });
    return transactionCatData;
  }

  getCBDCustomer() {
    if (!this.CBD) {
      let inputMap = new Map();
      inputMap.clear();
      this.http.fetchApi("/cbd", "GET", inputMap, this.getEnvironment().accountsPublisher).subscribe(
        async (httpResponse: HttpResponse<any>) => {
          var res = httpResponse.body;
          if (httpResponse.status == 200) {
            if (res) this.CBD = res.cbd;
          }
        },
        async (httpError) => {
          var err = httpError["error"];
          if (
            err != null &&
            err["ErrorElementPath"] != undefined &&
            err["ErrorDescription"] != undefined
          ) {
          }
        }
      );
    }
  }

  async getCustomerData() {
    let inputMap = new Map();
    inputMap.clear();
    inputMap.set('PathParam.userId', this._userService.getCustomerCode());
    await this.http.fetchApi('/customer/{userId}', 'GET', inputMap, this.getEnvironment().customersPublisher)
      .subscribe(
        async (httpResponse: HttpResponse<any>) => {
          var res = httpResponse.body;
          if (httpResponse.status == 200) {
            this.personalDetails = res.personalDetails;
          }
        },
        async (httpError) => {
          var err = httpError["error"];
          if (
            err != null &&
            err["ErrorElementPath"] != undefined &&
            err["ErrorDescription"] != undefined
          ) {
          }
        }
      );
  }

  //Get greenifiable transactions per category per month.
  async getGreenifiedTransactions(accountNumber, month, year, categoryId) {
    let inputMap = new Map();
    let transactions = []
    inputMap.clear();
    inputMap.set('PathParam.accountNumber', accountNumber);
    //inputMap.set('PathParam.accountNumber','0000000714');
    inputMap.set('PathParam.categoryId', categoryId)
    //inputMap.set('PathParam.categoryId','ELEC');
    // inputMap.set('QueryParam.calendarMonth', month +1);
    inputMap.set('QueryParam.calendarMonth', month);
    inputMap.set('QueryParam.calendarYear', year);
    await this.http.fetchApi('/greenification/{accountNumber}/category/{categoryId}', "GET", inputMap, this.getEnvironment().accountsPublisher).toPromise().then(
      async (httpResponse: HttpResponse<any>) => {
        var res = httpResponse.body;
        //console.log('transactions')
        //console.log(res)
        var greenificationDetails = res ? res['greenificationDetails'] : res;

        if (greenificationDetails) {
          for (var i = 0; i < greenificationDetails.length; i++) {
            var tempObj = {};
            tempObj['transactionDate'] = greenificationDetails[i]['transactionDate'];
            tempObj['remainingCarbonFootprint'] = greenificationDetails[i]['totalAvlCo2Emission'];
            tempObj['totalCarbonFootprint'] = greenificationDetails[i]['totalCo2Emission'];
            tempObj['greenifiedCarbonFootprint'] = greenificationDetails[i]['totalGreenCo2Emission'];
            tempObj['merchantName'] = greenificationDetails[i]['merchantName'];
            tempObj['transactionType'] = greenificationDetails[i]['transactionDescription']
            transactions.push(tempObj);
          }
        }


      }, async (httpError) => {
        var err = httpError["error"];
        if (
          err != null &&
          err["ErrorElementPath"] != undefined &&
          err["ErrorDescription"] != undefined
        ) {
        }
      }
    );
    console.log('transactions')
    console.log(transactions);
    return transactions;
  }

  async loadPaymentMethod() {

    let inputMap = new Map();
    inputMap.clear();
    inputMap.set('PathParam.userId', sessionStorage.getItem('customerCode'));
    await this.http.fetchApi('/paymentmethod', 'GET', inputMap, this.getEnvironment().customersPublisher)
      .subscribe(
        async (httpResponse: HttpResponse<any>) => {
          var res = httpResponse.body;
          (res && res.paymentmethod) ? this.paymentMethodData = res.paymentmethod : undefined;
        },
        async (httpError) => {
          var err = httpError["error"];
          if (
            err != null &&
            err["ErrorElementPath"] != undefined &&
            err["ErrorDescription"] != undefined
          ) {
          }
        }
      );
  }




}
